import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { Documento } from './documento';
import { DocumentoService } from './documento.service';

import { TipoCertificadoService } from './../tipos_certificados/tipo_certificado.service';
import { TipoCertificado } from './../tipos_certificados/tipo_certificado';

import { Usuario } from './../usuario/usuario';

@Component({
  selector: 'app-documentos',
  templateUrl: './lista.component.html',
  styleUrls: ['./documentos.component.css'],
  providers: [DocumentoService, TipoCertificadoService, Usuario]
})

export class DocumentosComponent  implements OnInit {

  public documentos: Documento[];
  public tipoCertificados: TipoCertificado[];
  public titulo: string = "Documentos";
  public params:any = {nome: undefined, tipo:undefined, criado_em_from:undefined, criado_em_to:undefined};
  public mask = [ /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public busy: Promise<any>;
  public paginaAtual: number = 1;
  public itensPorPagina: number = 1;
  public totalItens: number = 1;
  public dataOptions = [{
    format: 'dd/mm/yyyy',
    monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mar', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    monthsFull: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    weekdaysFull: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'],
    weekdaysShort: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
    today: 'Hoje',
    clear: 'Limpar',
    close: 'OK',
    closeOnSelect: true
  }];

  private carregando = false;

  constructor(
    private documentoService: DocumentoService,
    private _flashMessagesService: FlashMessagesService,
    private tipoCertificadoService: TipoCertificadoService,
    private router: Router,
    private usuario: Usuario
  ) {
  }

  getDocumentos(): void {
    this.params['page'] = this.paginaAtual;
    this.busy = this.documentoService.getDocumentos(this.params)
      .then(documentos => this.carregar(documentos));
  }

  carregar(documentos: any): void{
    this.documentos = documentos.data;
    this.paginaAtual = documentos.current_page;
    this.totalItens = documentos.total;
    this.itensPorPagina = documentos.per_page;
  }

  goEditar(docId:number): void{
    this.carregando = true;
    setTimeout(() => {
      this.router.navigate(['/documento/' + docId]);
      this.carregando = false;
    }, 2000);
  }
  
  copiar(id: number): void{
    this.busy = this.documentoService.copiarDocumento(id)
            .then(() => this.getDocumentos());
  }

  apagar(documento: Documento): void {
  //  this.toastyService.default('Hi there');

    if(confirm("Deseja realmente excluir esse documento? Essa operação não pode ser revertida após a confirmação.")){
      this.busy = this.documentoService.deleteDocumento(documento)
            .then(() => this.getDocumentos());
    }
  }

  getTipoCertificados(): void{
    this.tipoCertificadoService.getTipos()
        .then((response) => this.tipoCertificados = response);
  }

  pageChanged(page: any): void{
    this.paginaAtual = page;
    this.getDocumentos();
  }

  ngOnInit() {
    this.getDocumentos();
    this.getTipoCertificados();
  }

}



// WEBPACK FOOTER //
// ./src/app/documentos/documentos.component.ts